import { render, staticRenderFns } from "./create.vue?vue&type=template&id=bd4ead52&scoped=true&"
import script from "./create.vue?vue&type=script&lang=js&"
export * from "./create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4ead52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd4ead52')) {
      api.createRecord('bd4ead52', component.options)
    } else {
      api.reload('bd4ead52', component.options)
    }
    module.hot.accept("./create.vue?vue&type=template&id=bd4ead52&scoped=true&", function () {
      api.rerender('bd4ead52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/taskMgr/patrolWorkOrderMgr/mobile/create.vue"
export default component.exports